import React from "react";
import { Link, useHistory } from "react-router-dom";

import { TextField, FunctionField } from "react-admin";

import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { isAuthorized } from "../../../utils/appUtils";
import { AclType, CarrierType, OutboundStatus } from "../../../utils/constants";
import { getFormTab } from "../../../utils/utils";

import { PhotoViewer } from "../../../components/common/PhotoViewer";
import ShipsTogetherAside from "../../../components/common/shipWith/ShipsTogetherAside";

import { statusRenderer } from "../../../managerApp/resources/outboundShipments/OutboundUtils";

const useAsideStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "18em",
      minWidth: "18em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

/**
 * Where a sibling opens for a customer: the same rule as the list's row click.
 * Only a rejected advice is theirs to edit; everything else is viewed.
 */
const siblingPath = (member) =>
  member.status === OutboundStatus.ADVICE_REJECTED
    ? `/outbounds/${member.id}`
    : `/outbounds/${member.id}/show`;

export const OutboundAdviceAside = ({
  backPath,
  history: historyProp,
  record,
  ...props
}) => {
  const classes = useAsideStyles();
  const routerHistory = useHistory();
  const history = historyProp || routerHistory;
  var tab = getFormTab(props);
  const linkBackPath = backPath
    ? [...backPath, props.location.pathname]
    : [props.location.pathname];

  if (!record || tab === "1" || tab === "pickList") return null;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Status:
            </Typography>
            <br />
            <FunctionField
              source="status"
              record={record}
              render={statusRenderer}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              PO Number:
            </Typography>
            <br />
            <TextField source="poNumber" record={record} />
          </Grid>
          <ShipsTogetherAside
            record={record}
            history={history}
            backPath={backPath}
            editPath={siblingPath}
          />
          {record.railCarNumber && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                {record.carrierType === CarrierType.RAIL
                  ? "Railcar Number:"
                  : "Trailer Number:"}
              </Typography>
              <br />
              <TextField source="railCarNumber" record={record} />
            </Grid>
          )}
          {record.pickupNumber && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Pickup Number:
              </Typography>
              <br />
              <TextField source="pickupNumber" record={record} />
            </Grid>
          )}
          {record.invoice && isAuthorized(AclType.INVOICES) && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Invoice
              </Typography>
              <br />
              <Link
                to={{
                  pathname: `/invoices/${record.invoiceId}`,
                  state: { backPath: linkBackPath },
                }}
              >
                <Typography variant="body2" color="primary">
                  {record.invoice.invoiceNumber} : $
                  {record.invoice.total.toLocaleString(undefined, {
                    style: "currency",
                    currency: "USD",
                  })}
                </Typography>
              </Link>
            </Grid>
          )}
          {record.bolNumber && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                BOL Number:
              </Typography>
              <br />
              <TextField source="bolNumber" record={record} />
            </Grid>
          )}
          {record.photos?.items?.length > 0 && (
            <PhotoViewer photos={record.photos?.items} />
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
